import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { useQueryResource } from '@hooks';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { paginationDefaultQueryParams, paginationFallbackQueryParams, PeriscopePaginatedList } from '..';
import { PeriscopeProfileList, ProfileSearch } from '.';
import React, { useCallback } from 'react';
export const SearchableProfileList = ({ parentIndex, showTitle, uri }) => {
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, paginationDefaultQueryParams), { hasEditAccess: null }),
        fallbackParams: paginationFallbackQueryParams,
        uri
    });
    const renderList = useCallback((items) => React.createElement(PeriscopeProfileList, { items: items, parentIndex: parentIndex, sonarObjectType: SonarObjectType.SalesforceProfile }), [parentIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ProfileSearch, { onChange: updateParams }),
        React.createElement(PeriscopePaginatedList, { list: renderList, loading: loading, onChange: updateParams, queryParams: queryParams, resource: resource, title: showTitle ? PERISCOPE_TAB_TYPES.PROFILES : '' })));
};
